import DashboardLayout from '../layouts/DashboardLayout';
import { Outlet } from 'react-router-dom';

const DashboardComptable = () => {
  return (
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
  );
};

export default DashboardComptable;
